import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import {HowToVote} from "@material-ui/icons";
import ListItemText from "@material-ui/core/ListItemText";
import React from "react";
import Chip from "@material-ui/core/Chip";
import {getMessage} from "../../util";

const QuestionItem = (props) => {

    const getState = (state) => {
        switch (state) {
            case 'open':
                return (<Chip label={getMessage(props.meeting.meeting_type,'question_open',props.messages)}/>);
            case 'finished':
                return (<Chip label={getMessage(props.meeting.meeting_type,'question_finished',props.messages)}/>);
            default:
                return (<Chip label={getMessage(props.meeting.meeting_type,'question_ready',props.messages)}/>);

        }
    }
    function ListItemLink(props) {
        return <ListItem button component="a" {...props} />;
    }

    return (
        <ListItem button>
            <ListItemIcon>
                <HowToVote/>
            </ListItemIcon>
            <ListItemLink href={"/meeting/question/"+props.question.slug}>

            <ListItemText
                primary={props.question.name}
            />
            <ListItemIcon>
                {getState(props.question.state)}
            </ListItemIcon>
            </ListItemLink>


        </ListItem>
    )
}

export default QuestionItem;